







































































































import {Vue, Component} from 'vue-property-decorator';
import Paginition from '@/components/Paginition.vue';
import FilterMenu from '@/components/FilterMenu.vue';
import {Filter} from '@/utils/Filter';
import News from '@/models/news';

import {API} from '@/services/api/api';
import {Utils} from '@/utils/Utils';
import {mapActions} from 'vuex';
import {updateNotificationStatus} from '@/services/api/notifications';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    Paginition,
    FilterMenu,
  },
})
export default class NewsUpdateTab extends Vue {
  //header filter(true false for showing filter menu)
  header = [
    {
      value: 'newsHeading',
      name: 'Notification Title',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'newsDescription',
      name: 'Description',
      headerType: 'text',
      asdcOrder: true,
      filter: true,
      sortable: true,
      bindClass: 'desc-width',
    },
    {
      value: 'status',
      name: 'Status',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },

    {
      value: 'newsCreateDate',
      name: 'Created',
      headerType: 'date',
      asdcOrder: true,
      filter: true,
      sortable: true,
    },
    {
      value: 'edit',
      name: 'Edit',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
    {
      value: 'delete',
      name: 'Delete',
      headerType: 'text',
      filter: false,
      sortable: false,
      bindClass: 'text-center',
    },
  ];

  //Store Variable
  showSuccessToast: any;
  showErrorToast: any;

  //Modal & Loader Variable
  modalVisible = false;
  modalConfimationMsg: any = null;
  modalTitle: any = null;
  isScreenLoading = true;
  deleteStatus = false;

  //List Variables
  newsId: any = null;
  newsList: News[] = [];
  filteredNewsList: News[] = []; //api response

  //Sort Variable
  asdcOrder = true;
  curentSort = '';

  //Paginition Variables
  startingPoint: number = 0;
  endingPoint: number = 5;

  //sorting list
  clickOnSort(header: any) {
    if (this.curentSort !== header.value) {
      this.curentSort = header.value;
      this.asdcOrder = true;
    }

    let sorted = Utils.sortData(this.asdcOrder, header, this.filteredNewsList);
    this.asdcOrder = sorted;
  }

  mounted() {
    this.getNewsList();
  }

  //pagination value listener show data based on pagination
  onPaginitionValueChange(startingPoint: number, endingPoint: number) {
    this.startingPoint = startingPoint - 1;
    this.endingPoint = endingPoint;
  }

  // format date to human readable string
  formatDate(originalDate: string) {
    let formattedDate = Utils.formatDate(originalDate);
    return formattedDate;
  }

  // load list from api
  public async getNewsList() {
    try {
      let response = await API.fetchNewsList();
      this.isScreenLoading = false;
      if (response.data !== '' && response.data !== null) {
        let news: News[] = response.data;
        this.newsList = news;
        this.filteredNewsList = news;
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //filter data based upon string parameters
  filterOnText(emittedFilterParams: any) {
    let filteredData = Filter.filterOnTextData(emittedFilterParams, this.newsList);

    this.filteredNewsList = filteredData;
    this.resetPagination();
  }

  //filter data based upon date parameters
  filterOnDate(emittedFilterParams: any) {
    let filteredData = Filter.filterOnDateData(emittedFilterParams, this.newsList);
    this.filteredNewsList = filteredData;
    this.resetPagination();
  }

  //reset all filters and show complete list of data
  resetFilter(isDefaultList: boolean) {
    if (isDefaultList) this.filteredNewsList = this.newsList;
  }

  //show delete confirmation  modal

  displayDeleteModal(recordId: number) {
    this.newsId = recordId;
    this.modalVisible = true;
    this.modalTitle = 'Delete Confirmation';
    this.modalConfimationMsg = 'Are you sure want to delete ?';
    this.deleteStatus = true;
  }

  //show activate/deactivate  confirmation  modal
  displayStatusModal(recordId: number, recordStatus: boolean) {
    this.newsId = recordId;

    let msg;
    if (recordStatus) msg = 'Deactivate';
    else msg = 'Activate';
    this.modalVisible = true;
    this.modalTitle = `${msg} Confirmation`;
    this.modalConfimationMsg = `Are you sure want to ${msg.toLowerCase()} ?`;
    this.deleteStatus = false;
  }

  //call delete or activate/deactivate method based upon confirmation
  public async deleteOrChangeStatus() {
    try {
      const response = this.deleteStatus ? await this.deleteNews(this.newsId) : await this.changeStatus(this.newsId);
      let message = '';
      if (this.deleteStatus) {
        message = response.data.error ? response.data.error : 'Record deleted successfully';
      } else {
        message = 'Record updated successfully';
      }

      if (response) {
        this.showSuccessToast({msg: message});
        this.getNewsList();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //delete record
  async deleteNews(newsId) {
    return await API.deleteNewsById(this.newsId);
  }

  // change status of news
  async changeStatus(newsId) {
    let source = 'news';
    const news = this.newsList.find((u) => u.newsId === newsId);
    updateNotificationStatus(newsId, !news.newsIsActive);
    return new Promise((resolve) => setTimeout(() => resolve(true), 1500));
  }

  //reset pagination to first page
  resetPagination() {
    const pagination: any = this.$refs.pagination;
    setTimeout(() => {
      pagination.reset();
    }, 150);
  }

  // navigate to edit-news screen
  editNews(newsId: string) {
    this.$router.push({path: '/edit-notification/' + newsId});
  }
}
